import { Controller } from "@hotwired/stimulus"
import { baseKit } from "../shared/browserKit"
import { begin } from "../shared/functions"

// Connects to data-controller="assignee-selector"
export default baseKit(({
  useVisibility,
  useInputComposition,
  selectElement,
  dispatchElement,
})=>{
   return class extends Controller {
    static values = {
      loadOnConnect: { type: String, default: null },
      selected: { type: Array, default: null },
    }

    static targets = [
      "searchInput",
      "turboListItem",
    ]

    connect() {
      // const controller = this
      this.$visibility = useVisibility(this.element, (current)=>{
        const initCompoisition = (visibilityComposition)=>{
          useInputComposition({ search: this.searchInputTarget }, (current)=>{
            return {
              init(newValue){
                this.composition(newValue, { applyIfMatched: false })
              },
              composition: ({ search }, option = { applyIfMatched: true })=>{
                console.log('search', search)
                const groupOfLi = this.groupByTurboListItemWithKeyword(search)
                if(option?.applyIfMatched === true && groupOfLi.matched.length === 0){
                  
                } else {
                  groupOfLi.matched.forEach((li)=>li.classList.remove('hidden'))
                  groupOfLi.unmatched.forEach((li)=>li.classList.add('hidden'))
                  this.turboListItemTargets.forEach((li)=>{
                    const isSelectedItem = this.selectedValue.some(({ id })=>{
                      return String(id) === String(li.dataset.id)
                    })
                    if(isSelectedItem){
                      li.attributeStyleMap.set('order', '0')
                    } else {
                      li.attributeStyleMap.set('order', '1')
                    }
                  })
                }
              },
            }
          })
          setTimeout(()=>{
            visibilityComposition.destroy()
          })
        }
        if(current.visible){
          initCompoisition(current)
        }
        return {
          visible: ()=>{
            if(current.visible){
              initCompoisition(current)
            }
          }
        }
      })
    }

    disconnect (){
      this.$visibility.destroy()
    }

    loadSearch (){

    }

    // 검색어 입력시 목록을 필터링 하여 엘리먼트에 적용
    groupByTurboListItemWithKeyword (search){
      const liTargets = this.turboListItemTargets
      const [ matched, unmatched ] = liTargets.reduce(([ matched, unmatched ], li)=>{
        const { dataset: { id, primary_name, primary_phone, personal_address } } = li
        let matchedValue = false
        if (id && id.includes(search)) {
          matchedValue = true
        } else if (primary_name && primary_name.includes(search)) {
          matchedValue = true
        } else if (primary_phone && primary_phone.includes(search)) {
          matchedValue = true
        } else if (personal_address && personal_address.includes(search)) {
          matchedValue = true
        }
        if (matchedValue) {
          matched.push(li)
        } else {
          unmatched.push(li)
        }
        return [ matched, unmatched ]
      },[[],[]])
      return {
        length: liTargets.length,
        matched, 
        unmatched,
      }
    }

    // 아이템 이벤트 
    defineTurboListItemDataWithElement(target){
      const currentChecked = selectElement([target, 'input'], (checkbox)=>checkbox.checked)
      const { assigneeSelectorTarget, ...datasetData } = target.dataset
      return Object.defineProperties({
        ...datasetData,
      }, {
        checked: {
          enumerable: false,
          configurable: false,
          get (){
            return currentChecked
          }
        },
        target: {
          enumerable: false,
          configurable: false,
          get (){
            return target
          },
        }
      })
    }

    $handleItemChecked (event){
      dispatchElement(event.target, 'assignee-selector:checked', begin((self = this)=>({
        get currentTurboListItems (){
          return self.turboListItemTargets.map(self.defineTurboListItemDataWithElement)
        },
        get currentCheckedTurboListItems (){
          return self.turboListItemTargets
            .filter((target)=>selectElement([target, 'input'], (checkbox)=>checkbox.checked))
            .map(self.defineTurboListItemDataWithElement)
        }
      })))
    }

    turboListItemTargetConnected (element){
      console.log('element', element)
      const isSelectedItem = this.selectedValue.some(({ id })=>{
        return String(id) === String(element.dataset.id)
      })
      if(isSelectedItem){
        element.attributeStyleMap.set('order', '0')
      } else {
        element.attributeStyleMap.set('order', '1')
      }
      selectElement([element, 'input'], (checkbox)=>{
        checkbox.checked = isSelectedItem
        checkbox.addEventListener('change', this.$handleItemChecked.bind(this))
      })
    }

  }
})
